import React from 'react'

class AboutContent extends React.Component {
  render() {
    return (
     <section id="About">
      <div className="container">
       <div className="Container about_section">
          <h1 data-aos="fade-right"><b>About me</b></h1>
          <div className="underline_brick"></div><br />
            <p>Hello! My name is <span className="name">Justin Edobor. </span>
              I'm a <font>Frontend Web Developer</font> specialized in building and designing exceptional digital experiences. I am an Engineer valued at driving high-performance accessible web experiences.<br /><br />  I develop responsive websites and web apps that provide users the best and most appropriate experience suited to their device and browser that are  fast, easy to use, beautiful and built with best practices.<br /><br />Here are a few technologies i work with:</p>
       <div className="container-fluid technologies_list">
          <div className="row">
				<div className="col-md-3 tools_list">
					<ul>
						<li class="technologies_items"><i className="material-icons">check_circle</i> HTML</li>
						<li class="technologies_items"><i className="material-icons">check_circle</i> CSS</li>
						<li class="technologies_items"><i className="material-icons">check_circle</i> Bootstrap</li>
						<li class="technologies_items"><i className="material-icons">check_circle</i> React.js</li>
					</ul>
				</div>
				<div className="col-md-3 tools_list">
					<ul>
						<li class="technologies_items"><i className="material-icons">check_circle</i> JavaScript</li>
						<li class="technologies_items"><i className="material-icons">check_circle</i> Vue.js</li>
						<li class="technologies_items"><i className="material-icons">check_circle</i> Node.js</li>
						<li class="technologies_items"><i className="material-icons">check_circle</i> Git</li>
					</ul>
				</div>
           </div>
        </div>
     <div className="about_links">
          <a href="https://drive.google.com/uc?id=1OgI2Ek7yFJi4W3xsMIQ9vvg401mGYW80&export=download"><button className="index_contact_btn btn_inverse icon_btn"  data-aos="fade-up"><i className="material-icons-outlined">cloud_download</i> Download CV</button></a><br />
          <a href="#Contact"><button className="index_contact_btn icon_btn"  data-aos="fade-up"><i className="material-icons-outlined">email</i> Hire me</button></a>
     </div>
   </div>
  </div>
 </section>
       )
  }
}

export default AboutContent;